// extracted by mini-css-extract-plugin
export default {"input":"input--a66436cb","editable":"editable--51ea5285","readonly":"readonly--bedcc8ae"};